import { NavigationExtras } from '@angular/router';

import { HeaderPageType } from '@header/entities/ds-header-config';

export interface RouterUrlState {
  commands: Object[];
  extras?: NavigationExtras;
}

export type RouterGlobalState = Readonly<{
  previousUrl: RouterUrlState;
  currentUrl: RouterUrlState
}>;

export const ROUTER_STATE_DEFAULT: RouterGlobalState = {
  previousUrl: {
    commands: []
  },
  currentUrl: {
    commands: []
  }
};

export interface HistoryItem {
  url: string;
  extras?: NavigationExtras;
}

export interface HistoryValidator {
  rootItemUrl: string;
  lastRootItemUrl: string;
  replaceRoute: boolean;
  addNewItem: boolean;
}

export interface NavigationItem {
  Url: string;
  PageType: HeaderPageType;
  Extras?: NavigationExtras;
}
